import React from 'react';
import { View, Text, Image, ScrollView,StyleSheet, Dimensions , TouchableWithoutFeedback, ActivityIndicator } from 'react-native';
// import BackHandlerAndroid from './../AndroidBackHandler';
import { Styles } from './../../components/UI-Components';
import { getAllFacultyList, clearAllFacultyListInfoData } from './../../store/actions';
import { connect } from 'react-redux';
import LoadingComponent from "./../../components/LoaderComponent";
import Header from "./../../components/Header";
import Container from '@material-ui/core/Container';
import { Surface } from 'react-native-paper'



const { width, height } = Dimensions.get("window");
const facultyData = [
    {
      name: 'Mahira',
      subject: 'Maths',
      uri: 'https://randomuser.me/api/portraits/women/66.jpg',
      experience: 5
    },
    {
      name: 'Jack',
      subject: 'Social',
      uri: 'https://randomuser.me/api/portraits/men/43.jpg',
      experience: 3
    },
    {
      name: 'Stuart',
      subject: 'Economics',
      uri: 'https://randomuser.me/api/portraits/men/86.jpg',
      experience: 6
    },
    {
      name: 'Sana',
      subject: 'General',
      uri: 'https://randomuser.me/api/portraits/women/2.jpg',
      experience: 10
    },
    {
      name: 'Asim',
      subject: 'Politics',
      uri: 'https://randomuser.me/api/portraits/men/77.jpg',
      experience: 15
    },
  ]

class AllFacultyListScreen extends React.Component {

state = {
  facultyInfo: [],
  isTrue: false
}

 componentDidMount(){
  this.props.getAllFacultyList()
 }

 componentDidUpdate(prevProps){
    if(prevProps.facultyInfo !== this.props.facultyInfo){
      if(this.props.facultyInfo){
        this.setState({
          facultyInfo: this.props.facultyInfo
        }, () => {
          let lastIndex = this.state.facultyInfo.length;
          const lastItem = this.state.facultyInfo[lastIndex - 1];
          
          if(lastItem) {
             this.setState({
               isTrue: true
             })
          }
        })
      }
    }
   
 }
  render(){
    // console.log(this.props.c, "asdasdns")
    const { facultyInfo, isTrue } = this.state;
  
    return(
        <>
          <Header
            title="Faculty Info"
          />
            <Container maxWidth='lg'>
            <div className='main-component'
              style={{marginTop: 10}}
            >
        {/* <BackHandlerAndroid goBack={true}/> */}
        {
          this.props.loading &&
          <View style={{flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff'}}>
            <LoadingComponent styles={{width: 250, height: 250}}/>
          </View>
        }
        {
          this.props.error &&
          <View style={{flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff'}}>
          <Text styles={{fontSize: 18, fontWeight: '600'}}> Faculty List Not Found</Text>
        </View>

        }
        <View style={styles.main}>
            <View style={styles.facultyList}>
            <ScrollView>
            <View style={{ flex: 1, flexDirection: 'row', flexWrap: 'wrap', marginBottom: 50,  justifyContent: isTrue ? 'flex-start' : 'center'}}>
                
            {
            facultyInfo?.length > 0  && facultyInfo.map((data,index) => {
              
              
               return(
              
                <Surface style={[styles.facultyComponent]}  key={index}>
                    <View style={styles.imageComponent}>
                        <Image
                        source={{uri: data.profile_pic}}
                        style={{width: '100%', height: '100%'}}
                        // resizeMode='center'
                        />
                    </View>
                    <View style={{marginTop: 5, justifyContent:'center', alignItems: 'center'}}>
                     <Text style={styles.name}
                       ellipsizeMode='tail'
                       numberOfLines={1}
                     >{data.first_name}</Text>
                     <Text style={styles.name}
                       ellipsizeMode='tail'
                       numberOfLines={1}
                     >{data.last_name}</Text>
                    </View>
                    <View>
                     <Text
                      style={styles.experience}
                      ellipsizeMode='tail'
                      numberOfLines={1}
                     >{data.experiance} years Experience</Text>
                    </View>
                    {/* <View>
                     <Text style={styles.experience}
                      ellipsizeMode='tail'
                      numberOfLines={1}
                     >{data.subject}</Text>
                    </View> */}
                </Surface>
               
               )
          
            })
            }
            </View>
            </ScrollView>
            </View>       
        </View>
        </div>
        </Container>
        </>

    )
}
}

const mapStateToProps = state => {
  const facultyInfo = state?.allFacultyListInfo?.response?.faculty;
  const loading = state?.allFacultyListInfo?.loading;
  const error = state?.allFacultyListInfo?.error;

  return {
    facultyInfo,
    loading,
    error
  }
}

export default connect(mapStateToProps, {clearAllFacultyListInfoData, getAllFacultyList} )(AllFacultyListScreen)


const styles = StyleSheet.create({
    main: {
        flex: 1,
        backgroundColor: '#fff',
    
    },
    facultyList: {
        flexDirection: 'column', 
        flexWrap: 'wrap',
        marginTop:10,
        
       
    },
    facultyComponent:{
        marginTop:10,
        // height: 150,
        width: width <= 479 ? Math.floor(width/2 - 50): '25%',
        // width: '30%',
        marginHorizontal: 15,
        marginHorizontal: 15,
        // marginBottom,
        marginTop:10,
        // justifyContent: 'flex-start',
        // elevation: 6,
        alignItems: 'center',
        // backgroundColor: '#fff',
        paddingVertical: 10,
        paddingHorizontal: 6,
        
        
    },
    imageComponent: {
        height: 100, 
        width: 100,
        borderWidth: 1, 
        borderColor: Styles.secondaryThemeColor,
        borderRadius: 50, 
        overflow: 'hidden',
        // elevation: 6
        marginBottom: 10,
        marginVertical: 5
    },
    name: {
        fontSize: 14,
        fontWeight: '700',
        color: Styles.secondaryThemeColor,


    },
    experience: {
        fontSize: 13,
        fontWeight: '600',
        color: Styles.testSeriesListColor
    }

})